/* eslint-disable import/no-anonymous-default-export */
// Author : Vishnu
// Version :0.0.1
// MODIFIED DATE: 03/09/2025
import RangeLoanProposalActionTypes from './range-product-loan-proposal.types';
import { docodeHexResponse } from '../../../_common/common.utils';

const INITIAL_STATE = {
	getRangeProposalResponse: null,
	getRangeProposalListArr: [],
	getRangeProposalCenterListResponse: null,
	getRangeProposalCenterListArr: [],
	getCenterMemberListResponse: null,
	getCenterMemberListArr: [],
	getRangeProductListResponse: null,
	getRangeProductListArr: [],
	addRangeLoanProposalResponse: null,
	addRangeLoanProposalArr: [],
	updateRangeLoanProposalResponse: null,
	updateRangeLoanProposalArr: [],
	getCenterMemberLeadListResponse: null,
	getCenterMemberLeadListArr: [],
	getParticularLoanIndexDetailsResponse: null,
	getParticularLoanIndexDetailsArr: [],
	approveRangeLoanIndexResponse: null,
	revertApprovedRangeLoanIndexResponse: null,
	rejectRangeLoanIndexResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/************* GET RANGE LOAN PROPOSAL LIST START ********************/
		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_LIST_SUCCESS:
			return {
				...state,
				getRangeProposalResponse: action.payload,
				getRangeProposalListArr: docodeHexResponse(
					action.payload,
					'GetAllBranchLoanIndexDetailsKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_LIST_FAILURE:
			return {
				...state,
				getRangeProposalResponse: action.payload,
				getRangeProposalListArr: [],
			};

		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_LIST_RESPONSE_CHANGED:
			return { ...state, getRangeProposalResponse: null };
		/************* GET RANGE LOAN PROPOSAL LIST END ********************/

		/************* GET RANGE LOAN PROPOSAL CENTER LIST START ********************/
		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_SUCCESS:
			return {
				...state,
				getRangeProposalCenterListResponse: action.payload,
				getRangeProposalCenterListArr: docodeHexResponse(
					action.payload,
					'GetRangeLoanProposalCenterListKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_FAILURE:
			return { ...state, getRangeProposalCenterListResponse: action.payload };

		case RangeLoanProposalActionTypes.GET_RANGE_LOAN_PROPOSAL_CENTER_LIST_RESPONSE_CHANGED:
			return { ...state, getRangeProposalCenterListResponse: null };
		/************* GET RANGE LOAN PROPOSAL CENTER LIST END ********************/

		/************* GET CENTER MEMBER LIST START ********************/
		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LIST_SUCCESS:
			return {
				...state,
				getCenterMemberListResponse: action.payload,
				getCenterMemberListArr: docodeHexResponse(
					action.payload,
					'GetMemberDetailsForCenterLoanKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LIST_FAILURE:
			return { ...state, getCenterMemberListResponse: action.payload };

		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LIST_RESPONSE_CHANGED:
			return { ...state, getCenterMemberListResponse: null };
		/************* GET CENTER MEMBER LIST END ********************/

		/************* GET RANGE PRODUCT LIST START ********************/
		case RangeLoanProposalActionTypes.GET_RANGE_PRODUCT_LIST_SUCCESS:
			return {
				...state,
				getRangeProductListResponse: action.payload,
				getRangeProductListArr: docodeHexResponse(
					action.payload,
					'GetRangeLoanProposalProductListKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_RANGE_PRODUCT_LIST_FAILURE:
			return { ...state, getRangeProductListResponse: action.payload };

		case RangeLoanProposalActionTypes.GET_RANGE_PRODUCT_LIST_RESPONSE_CHANGED:
			return { ...state, getRangeProductListResponse: null };
		/************* GET RANGE PRODUCT LIST END ********************/

		/************* ADD RANGE LOAN PROPOSAL START ********************/
		case RangeLoanProposalActionTypes.ADD_RANGE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				addRangeLoanProposalResponse: action.payload,
				addRangeLoanProposalArr: docodeHexResponse(
					action.payload,
					'AddRangeLoanProposaltKey',
				),
			};

		case RangeLoanProposalActionTypes.ADD_RANGE_LOAN_PROPOSAL_FAILURE:
			return { ...state, addRangeLoanProposalResponse: action.payload };

		case RangeLoanProposalActionTypes.ADD_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, addRangeLoanProposalResponse: null };
		/************* ADD RANGE LOAN PROPOSAL END ********************/

		/************* UPDATE RANGE LOAN PROPOSAL START ********************/
		case RangeLoanProposalActionTypes.UPDATE_RANGE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				updateRangeLoanProposalResponse: action.payload,
				updateRangeLoanProposalArr: docodeHexResponse(
					action.payload,
					'UpdateRangeLoanProposaltKey',
				),
			};

		case RangeLoanProposalActionTypes.UPDATE_RANGE_LOAN_PROPOSAL_FAILURE:
			return { ...state, updateRangeLoanProposalResponse: action.payload };

		case RangeLoanProposalActionTypes.UPDATE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, updateRangeLoanProposalResponse: null };
		/************* UPDATE RANGE LOAN PROPOSAL END ********************/

		/************* GET CENTER MEMBER LEAD LIST START ********************/
		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LEAD_LIST_SUCCESS:
			return {
				...state,
				getCenterMemberLeadListResponse: action.payload,
				getCenterMemberLeadListArr: docodeHexResponse(
					action.payload,
					'GetMemberLeadListKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LEAD_LIST_FAILURE:
			return { ...state, getCenterMemberLeadListResponse: action.payload };

		case RangeLoanProposalActionTypes.GET_CENTER_MEMBER_LEAD_LIST_RESPONSE_CHANGED:
			return { ...state, getCenterMemberLeadListResponse: null };
		/************* GET CENTER MEMBER LEAD LIST END ********************/

		/************* GET PARTICULAR LOAN INDEX DETAILS START ********************/
		case RangeLoanProposalActionTypes.GET_PARTICULAR_LOAN_INDEX_DETAILS_SUCCESS:
			return {
				...state,
				getParticularLoanIndexDetailsResponse: action.payload,
				getParticularLoanIndexDetailsArr: docodeHexResponse(
					action.payload,
					'GetParticularRangeLoanIndexKey',
				),
			};

		case RangeLoanProposalActionTypes.GET_PARTICULAR_LOAN_INDEX_DETAILS_FAILURE:
			return { ...state, getParticularLoanIndexDetailsResponse: action.payload };

		case RangeLoanProposalActionTypes.GET_PARTICULAR_LOAN_INDEX_DETAILS_RESPONSE_CHANGED:
			return { ...state, getParticularLoanIndexDetailsResponse: null };
		/************* GET PARTICULAR LOAN INDEX DETAILS END ********************/

		/************* APPROVE RANGE LOAN PROPOSAL START ********************/
		case RangeLoanProposalActionTypes.APPROVE_RANGE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				approveRangeLoanIndexResponse: action.payload,
			};

		case RangeLoanProposalActionTypes.APPROVE_RANGE_LOAN_PROPOSAL_FAILURE:
			return { ...state, approveRangeLoanIndexResponse: action.payload };

		case RangeLoanProposalActionTypes.APPROVE_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, approveRangeLoanIndexResponse: null };
		/************* APPROVE RANGE LOAN PROPOSAL END ********************/

		/************* REVERT APPROVED RANGE LOAN PROPOSAL START ********************/
		case RangeLoanProposalActionTypes.REVERT_APPROVED_RANGE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				revertApprovedRangeLoanIndexResponse: action.payload,
			};

		case RangeLoanProposalActionTypes.REVERT_APPROVED_RANGE_LOAN_PROPOSAL_FAILURE:
			return { ...state, revertApprovedRangeLoanIndexResponse: action.payload };

		case RangeLoanProposalActionTypes.REVERT_APPROVED_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, revertApprovedRangeLoanIndexResponse: null };
		/************* REVERT APPROVED RANGE LOAN PROPOSAL END ********************/

		/************* REJECT RANGE LOAN PROPOSAL START ********************/
		case RangeLoanProposalActionTypes.REJECT_RANGE_LOAN_PROPOSAL_SUCCESS:
			return {
				...state,
				rejectRangeLoanIndexResponse: action.payload,
			};

		case RangeLoanProposalActionTypes.REJECT_RANGE_LOAN_PROPOSAL_FAILURE:
			return { ...state, rejectRangeLoanIndexResponse: action.payload };

		case RangeLoanProposalActionTypes.REJECT_RANGE_LOAN_PROPOSAL_RESPONSE_CHANGED:
			return { ...state, rejectRangeLoanIndexResponse: null };
		/************* REJECT RANGE LOAN PROPOSAL END ********************/
		default:
			return state;
	}
};
